import * as React from 'react';
import { HomeGrid, HomeContent } from '../../components/UI/HomeUI';
import TopBar from '../Site/TopBar';
import { withThemer, ThemerProps } from '../../helpers/withThemer';
import { ThemeProvider } from 'styled-components';
import Footer from '../Site/Footer';

interface DashProps {
  children: React.ReactNode;
}

type Props = ThemerProps & DashProps;

const HomeLayout: React.SFC<Props> = ({ children, theme, updateTheme }) => (
  <ThemeProvider theme={{ mode: theme }}>
    <HomeGrid>
      <TopBar />
      <HomeContent>{children}</HomeContent>
      <Footer />
    </HomeGrid>
  </ThemeProvider>
);

export default withThemer(HomeLayout);



// WEBPACK FOOTER //
// ./src/containers/Layouts/HomeLayout.tsx